module.exports = __webpack_public_path__ + "img/celebrate.57ac5337.png";